import ApiServer from '@/utils/api/ApiServer.js'
import { saveAs } from 'file-saver'
import { utcToLocalDate } from '@/utils/DateFormatter.js'
import { SettlementCsvExportType } from '@/utils/Enumerations.js'

export default {
  async takeOnDemandSnapshot (_) {
    const path = 'adjustingentries'
    const response = await ApiServer.post(path)
    return response.data
  },

  async snapshotsList (_) {
    const path = 'adjustingentries'
    const response = await ApiServer.get(path)
    return response.data
  },

  async fetchSnapshot (_, timestamp) {
    const path = `adjustingentries/${timestamp.adjustingEntriesSnapshotRecordId}`
    const response = await ApiServer.get(path)
    return response.data
  },

  async patchSnapshotRecord (_, { snapshotRecordId, body }) {
    const url = ApiServer.urlFor(`adjustingentries/${snapshotRecordId}`)
    const response = await ApiServer.patch(url, body)
    return response.data
  },

  async fetchAdjustingEntriesCSV (_, { snapshotId, type, periodEndDate }) {
    const path = `adjustingentries/${snapshotId}/${type}`
    const response = await ApiServer.get(path, { headers: { 'Content-Type': 'text/csv' } })
    generateCSV(response.data, type, periodEndDate)
  }
}

const generateCSV = (csvData, name, periodEndDate) => {
  const parsedName = getCsvType(name)
  const csvFile = new Blob([csvData], { type: 'text/csv' })
  saveAs(csvFile, `${parsedName}_${utcToLocalDate(periodEndDate, 'YYYYMMDD')}.csv`)
}

const getCsvType = (type) => {
  const exportType = SettlementCsvExportType.enums.find(e => e.details.requestType === type)
  if (!exportType) return type

  switch (exportType) {
    case SettlementCsvExportType.AccountsPayable:
      return 'AP'
    case SettlementCsvExportType.Accruals:
      return 'AC'
    case SettlementCsvExportType.AccountsReceivable:
      return 'AR'
    case SettlementCsvExportType.StatisticalJournals:
      return 'SJ'
    default:
      return type
  }
}
